import React from "react";
import { createPortal } from "react-dom";
import "./SuccessmodalStyle.css";
import { thumb_up } from "../../assets/images";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  onNav: () => void;
  password?: boolean;
  confirmPassword?: boolean;
  classicMobileIcon?: boolean;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  message,
  onNav,
  password = false,
  confirmPassword = false,
  classicMobileIcon = false,
}) => {
  const accessToken = localStorage.getItem("access_token");

  const decodeToken = (token: string | null) => {
    if (!token) return null;
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      return JSON.parse(atob(base64));
    } catch (e) {
      return null;
    }
  };

  const decoded = decodeToken(accessToken);
  const roles = decoded?.roles || [];
  const isMerchantOnly = roles.length === 1 && roles[0] === "ROLE_MERCHANT";

  return createPortal(
    <div
      className={`modal ${isOpen ? "show" : ""}`}
      tabIndex={-1}
      style={{
        display: isOpen ? "block" : "none",
      }}
    >
      <div className="modal-dialog modal-dialog-centered p-2" role="document">
        <div
          className={`modal-content custom-modal2${classicMobileIcon ? " classic-mobile-success" : ""
            }`}
        >
          {password ||
            (confirmPassword && (
              <div className="cross d-flex flex-row-reverse ">
                <button
                  type="button"
                  className="close  btn  rounded-circle "
                  onClick={onClose}
                >
                  <span>&times;</span>
                </button>
              </div>
            ))}
          <div className="success-icon-wrapper">
            <div className="success-icon-desktop">
              <img
                src={thumb_up}
                width="90"
                height="90"
                alt="Logo"
                className="thumb"
              />
            </div>
            <div className="success-icon-mobile">
              {/* <div className="success-circle-outer">
                <div className="success-circle-middle">
                  <div className="success-circle-inner">
                    <span className="success-check">✓</span>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className="modal-header d-flex justify-content-center align-items-center p-0">
            <h5 className="modal-title">Success!</h5>
          </div>

          <div className="modal-body">
            <p
              className="text-light"
              dangerouslySetInnerHTML={{ __html: message }}
            ></p>
          </div>
          <div className="modal-footer d-flex justify-content-center p-0 mb-2 text-center">
            <button
              type="button"
              className={`btn btn-lg w-25 ${isMerchantOnly ? "success-confirm-btn" : "ok-button"}`}
              onClick={onNav}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SuccessModal;
